"use client";

import * as React from "react";

import { cn } from "@/lib/utils";

type MicroTextAs = "span" | "div" | "p";

export type MicroTextProps = {
  children: React.ReactNode;
  as?: MicroTextAs;
  className?: string;
};

/**
 * Fine metadata text — 10px/medium/muted. Use for secondary details that
 * should recede visually: timestamps, counts, short annotations.
 * Not uppercase (use Chip or text-overline for label pills).
 */
export function MicroText({ children, as: Element = "span", className }: MicroTextProps) {
  return (
    <Element
      className={cn(
        "text-[10px] font-medium leading-none tracking-wide text-muted-foreground",
        className,
      )}
    >
      {children}
    </Element>
  );
}
